/* eslint-disable no-shadow */
import React, { useState, createRef } from 'react';
import { Input } from 'reactstrap';

const EditField = ({ value, name, handleChange, enableBoxEdit }) => {
  const inputRef = createRef();

  const [isEditing, setIsEditing] = useState(false);

  const handleKeyUp = e => {
    const keyCode = typeof e.which === 'number' ? e.which : e.keyCode;
    const { name, value } = e.target;

    if (keyCode === 27) {
      setIsEditing(false);
    }
    if (keyCode === 13) {
      setIsEditing(false);
      handleChange(name, value);
    }
  };

  const handleBlur = e => {
    const { name, value } = e.target;
    setIsEditing(false);
    handleChange(name, value);
  };

  return (
    <>
      {isEditing && enableBoxEdit ? (
        <Input
          name={name}
          defaultValue={value}
          innerRef={inputRef}
          autoFocus
          onBlur={handleBlur}
          onKeyUp={handleKeyUp}
          className="editPropertyValue"
        />
      ) : (
        <span
          style={{ fontSize: value.length > 12 ? '24px' : '32px' }}
          className="propertyValue"
          onClick={() => setIsEditing(true)}
          title={value}
        >
          {value || 'N/A'}
        </span>
      )}
    </>
  );
};

export default EditField;
